import { FC } from "react"
import cx from "classnames"
import { MdOutlineKeyboardArrowLeft } from "react-icons/md"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const ArrowLeftIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <MdOutlineKeyboardArrowLeft
      className={cx("w-5 h-5 active:scale-90", className)}
      {...rest}
    />
  )
}

export default ArrowLeftIcon
